<template>
  <v-container grid-list-md fluid class="pt-0 pb-0">
    <v-card class="pa-2 card-r">
      <v-toolbar class="primary darken-2 card-r shadow-1 pl-3 text-white">
        <router-link to="/teachers"><v-icon class="text-white pr-2 left">keyboard_arrow_left</v-icon></router-link>
        <div class="text-xs-left f-20">Edit {{Teachers.Teachers.name}}</div>
      </v-toolbar>
      <v-card class="pa-2 no-shadow grey lighten-5">
              <v-form v-model="EditClub">
                  <v-container grid-list-md fluid class="pl-0 pr-0 pb-0">
                    <v-layout wrap>
                      <v-flex xs12>
                        <div class="f-15 textColor w-100 text-xs-left font-weight-bold">Personal</div>
                      </v-flex>
                      <v-flex xs12 lg4 class="pl-2">
                        <v-img :src="user.image_preview" class="shadow-1 cercle" height="150" width="150"></v-img>
                        <v-btn color="grey" @click="onPickImage('profile')" class="shadow-1 ma-0 my-2 text-white card-r">Change Profile image</v-btn>
                      </v-flex>

                      <input
                        type="file"
                        style="display:none"
                        ref="imageInput"
                        accept="image/png"
                        @change="OnImagePicked"
                      >

                      <v-flex xs12 lg8 class="pl-2">
                        <v-img size="36px" :src="user.cover_image_preview" class="CoverPhoto card-r"></v-img>
                        <v-btn color="grey" @click="onPickImage('cover')" class="shadow-1 ma-0 my-2 text-white card-r">Change Cover image</v-btn>
                      </v-flex>
                      <v-flex xs12 lg3>
                        <v-text-field
                          required
                          color="#749DBF"
                          type="text"
                          placeholder="User Name"
                          class="textFeald"
                          solo
                          label="Full Name"
                          v-model="user.name"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 lg3>
                        <v-menu
                          ref="menu"
                          v-model="menu"
                          :close-on-content-click="false"
                          :return-value.sync="user.dob"
                          lazy
                          transition="scale-transition"
                          persistent
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            placeholder="Birthday"
                            solo
                            required
                            slot="activator"
                            v-model="user.dob"
                            label="Birthday"
                            readonly
                          ></v-text-field>
                          <v-date-picker v-model="user.dob" no-title scrollable >
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                            <v-btn flat color="primary" @click="$refs.menu.save(user.dob)">OK</v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs12 lg3>
                        <v-text-field
                          required
                          color="#749DBF"
                          type="text"
                          placeholder="School Name"
                          class="textFeald"
                          solo
                          label="School Name"
                          v-model="user.schoolName"
                          disabled
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 lg3>
                        <v-text-field
                          required
                          color="#749DBF"
                          type="text"
                          placeholder="DD-12-312"
                          class="textFeald"
                          solo
                          label="Number plate code"
                          v-model="user.number_plate"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 lg6 class="mb-3">
                        <v-flex xs12 class="shadow-1 white">
                          <div class=" ml-2 f-12 text-xs-left textColor w-100  text-left">Gender</div>
                          <v-radio-group v-model="user.gender" style="margin-bottom: -23px!important;" row class="ma-0 pl-2">
                            <v-radio color="primary" label="Male" value="male"></v-radio>
                            <v-radio color="primary" label="Female" value="female"></v-radio>
                            <v-radio color="primary" label="Non-binary" value="non_binary"></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-flex>
                      <v-flex xs12 lg6 class="mb-3">
                        <v-flex xs12 class="shadow-1 white">
                          <div slot="label-top" class="active ml-2 text-xs-left w-100 text-primary f-9 pt-2">Address</div>
                          <vue-dawa
                            @select="selectItem($event, 'address')"
                            :val="address.oneLineAddress"
                            :showMax="5"
                            containerId="amdinAddress_container"
                            fieldId="amdinAddress_id"
                            fieldName="amdinAddress_name"
                          >
                            <!--<label slot="label-top" class="active">Address</label>-->
                          </vue-dawa>
                        </v-flex>
                      </v-flex>
                      <v-flex xs12 lg3>
                        <v-text-field
                          required
                          color="#749DBF"
                          type="text"
                          placeholder="Pickup Location"
                          class="textFeald"
                          solo
                          label="Pickup Location"
                          v-model="user.pickup_location"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 lg4>
                        <v-text-field
                          required
                          color="#749DBF"
                          class="textFeald"
                          solo
                          maxlength="8"
                          prefix="+45"
                          label="Phone Number"
                          placeholder="Phone Number"
                          :rules="[ v => v.length >= 8 || 'Min 8 characters']"
                          v-model="user.phone"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 lg4>
                        <v-text-field
                          required
                          color="#749DBF"
                          type="text"
                          placeholder="Email"
                          class="textFeald"
                          solo
                          label="Email"
                          v-model="user.email"
                        ></v-text-field>
                      </v-flex>
                       <v-flex xs12 lg4>
                    <v-text-field
                    required
                    color="#749DBF"
                    class="textFeald"
                    type="password"
                    solo
                    label="Password"
                    :rules="passwordRule"
                    placeholder="Password"
                    v-model="user.password"
                    ></v-text-field>
                  </v-flex>
                      
                      <v-flex xs12>
                        <div class="f-15 textColor w-100 text-xs-left font-weight-bold">Other Details</div>
                      </v-flex>
                      <v-flex lg4 xs12>
                        <v-text-field
                          required
                          v-model="user.qualification"
                          color="#749DBF"
                          class="textFeald"
                          solo
                          label="Qualifications"
                          placeholder="Qualifications"
                          multi-line
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg4 xs12>
                        <v-text-field
                          required
                          v-model="user.experience"
                          color="#749DBF"
                          class="textFeald"
                          solo
                          label="Experience"
                          placeholder="Experience"
                          multi-line
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg4 xs12>
                        <v-text-field
                          required
                          v-model="user.about_me"
                          color="#749DBF"
                          class="textFeald"
                          solo
                          label="About Me"
                          placeholder="About Me"
                          multi-line
                        ></v-text-field>
                      </v-flex>
                      <div class="f-15 textColor w-100 text-xs-left font-weight-bold">Payment details</div>

                      <v-flex xs12 lg4>
                        <v-text-field
                          required
                          color="#749DBF"
                          class="textFeald"
                          solo
                          type="number"
                          label="Rate per Class (45 mins)"
                          placeholder="Rate per Class (45 mins)"
                          v-model="user.amount"
                        ></v-text-field>
                      </v-flex>
                  <v-flex xs12 lg4>
                 <v-text-field
                    required
                    color="#749DBF"
                    class="textFeald"
                    type="password"
                    solo
                    label="Password"
                    :rules="passwordRule"
                    placeholder="Password"
                    v-model="user.password"
                  ></v-text-field>
                </v-flex>
                      <!-- <v-flex xs12>
                        <v-text-field
                          required
                          color="#749DBF"
                          class="textFeald"
                          solo
                          label="Discription"
                          placeholder="Discription"
                          v-model="discription"
                          multi-line
                        ></v-text-field>
                      </v-flex> -->
                      <v-flex md12 sm12 xs12 class="px-5">
                        <v-alert
                          :value="true"
                          v-bind:color="error.type[error.code].color"
                          v-bind:icon="error.type[error.code].icon"
                          v-if="errorStatus"
                          outline
                        >
                          {{error.message}}
                        </v-alert>
                        <v-progress-circular
                          indeterminate
                          color="primary"
                          v-if="loading"
                        ></v-progress-circular>
                      </v-flex>


                    </v-layout>

                  </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-2" class="no-shadow card-r" dark @click="UpdateInformation" >Update</v-btn>
                  </v-card-actions>
                </v-card-actions>
              </v-form>
          </v-card>
    </v-card>
    </v-container>
</template>

<script>
  /* eslint-disable */
  import { dispatch, mapState } from 'vuex'
  import VueDawa from "vue-dawa";
  import api from "../../../utils/backend-api.js"

  export default {
    props:["id"],
    name: "EditCustomer",
    data: () => ({
      ClubView:null,
      menu:false,
      passwordShow: false,
      EditClub: false,
      date: null,
      birthday: false,
      Membershipdata:null,
      Package_type: [],
      package_:[],
      coverPhoto: "https://s3.amazonaws.com/stg-drivers-license-assistance.org/images/blog/find-driving-teacher.jpg",
      teacherBlock:'',
      user:{
        image:'',
        image_preview:'',
        cover_image:'',
        cover_image_preview:'',
        schoolName:"",
        name: "",
        phone:"",
        club_number: "",
        gender: "",
        state: "",
        city: "",
        discription: "",
        password: "",
        email:"",
        dob:"",
        role: "teacher",
        address:{
          oneLineAddress:''
        },
        qualification:'',
        experience:'',
        about_me:''
      },
      address:{
        oneLineAddress:''
      },
      passwordRule: [
        v => !!v || "Password is required",
        v => v.length >= 8 || "Password must be at least 8 characters"
      ],
      phoneRule: [
        v => !!v || "Phone Number is required",
        v => v.length <= 8 || "Minimum 8 Digits valid number"
      ],
      errorStatus:false,
      error:{
        code:'',
        type:[{icon:"warning",color:'error'},{icon:"check_circle",color:'success'}],
        message:''
      },
      loading:'',
      image_for:'',
      temp:{
        temp_preview:[]
      }

    }),
    // beforeCreate(){
    // // },
    beforeDestroy(){
      // this.$store.state.ViweClubDetail=null
    },
    created(){
      var TeacherId=this.$route.params.id
      var Teachers=this.$store.state.Teachers.Teachers.Teachers
      this.user.schoolName=Store.state.user.club_name
      Store.dispatch('Teachers/getTeacherById',TeacherId)
        .then(res=>{
          console.log(res)
        })

      api.getData('admin/teacher/' + TeacherId)
        .then(res => {
          var teachers = res.data
          console.log(teachers)
          this.user.image_preview=teachers.image
          this.user.cover_image_preview=teachers.cover_image
          this.user.name=teachers.name
          this.user.email=teachers.email
          this.user.password=teachers.password
          this.user.phone=teachers.phone
          this.user.dob=teachers.dob
          //this.user.number_plate=teachers.number_plate

          this.setAddress(teachers)
          console.log(teachers)
          this.user.gender=teachers.gender

          self.user.experience=teachers.additional_detail.experience==('null' || null)?'':teachers.additional_detail.experience
          self.user.qualification=teachers.additional_detail.qualification==('null' || null)?'':teachers.additional_detail.qualification
          self.user.about_me=teachers.additional_detail.about_me==('null' || null)?'':teachers.additional_detail.about_me
          this.user.number_plate=teachers.additional_detail.number_plate
          this.user.pickup_location=teachers.pickup_location
        })

        api.postData('admin/viewTeacherRate',{teacher_id:TeacherId})
        .then(res => {
          if(res.status==201){
            this.user.amount=res.data.price_per_module
          }
        }).catch(err=>{
          this.user.amount=0
        })

      // for(var x=0;x<Teachers.length;x++){
      // if(Teachers[x].id==TeacherId){
      // this.teacherBlock=x

      // this.user.name=Teachers[x].name
      // this.user.email=Teachers[x].email
      // this.user.phone=Teachers[x].phone
      // this.user.dob=Teachers[x].dob

      // this.setAddress(Teachers[x])
      // console.log(Teachers[x])
      // this.user.gender=Teachers[x].gender
      // this.user.schoolName=Teachers[x].schoolName
      // break;
      // }
      // }
      // this.Membershipdata=this.$store.state.membership
      // // this.getclubData (this.id)
      // this.getpackage ()
      // this.pushToCustomer()
      // // this.getMembershipID(this.$store.state.ViweClubDetail.membership_id)

      // this.schoolName=this.$store.state.ViweClubDetail.name,
      // this.name=this.$store.state.ViweClubDetail.user.name,
      // this.date=this.$store.state.ViweClubDetail.user.dob,
      // this.phone=this.$store.state.ViweClubDetail.user.phone,
      // this.gender =this.$store.state.ViweClubDetail.user.gender,
      // this.state=this.$store.state.ViweClubDetail.user.state,
      // this.city=this.$store.state.ViweClubDetail.user.city,
      // this.discription=this.$store.state.ViweClubDetail.user.discription,
      // this.address=this.$store.state.ViweClubDetail.user.address,
      // this.adminemail=this.$store.state.ViweClubDetail.user.email,
      // this.zip=this.$store.state.ViweClubDetail.user.zip,
      // this.cancel_time=this.$store.state.ViweClubDetail.cancellation_time_period,
      // this.commission=this.$store.state.ViweClubDetail.commission
      // this.Package_type=this.getPackageName(this.$store.state.ViweClubDetail.membership_id)




    },
    methods: {
      UpdateInformation(){
        this.loading=true
        var adminData = {
          teacherId:this.$route.params.id,
          name: this.user.name,
          email: this.user.email,
          password:this.user.password,
          phone: this.user.phone,
          street: this.address.street,
          streetNumber: this.address.streetNumber,
          floor: this.address.floor,
          door: this.address.door,
          city: this.address.city,
          zip: this.address.zipCode,
          gender: this.user.gender.toLowerCase(),
          dob: this.user.dob,
          number_plate: this.user.number_plate,
          qualification:this.user.qualification,
          experience:this.user.experience,
          about_me:this.user.about_me,
          image:this.user.image,
          cover_image:this.user.cover_image,
          amount:this.user.amount,
          pickup_location:this.user.pickup_location
        };
        let formData=new FormData()
        formData.append('teacherId',this.$route.params.id)
        formData.append('name',this.user.name)
        formData.append('email',this.user.email)
        formData.append('password',this.user.password)
        formData.append('phone',this.user.phone)
        formData.append('street',this.user.street)
        formData.append('streetNumber',this.user.streetNumber)
        formData.append('floor',this.user.floor)
        formData.append('door',this.user.door)
        formData.append('city',this.user.city)
        formData.append('zip',this.user.zip)
        formData.append('gender',this.user.gender)
        formData.append('dob',this.user.dob)
        formData.append('number_plate',this.user.number_plate)
        formData.append('pickup_location',this.user.pickup_location)
        formData.append('qualification',this.user.qualification)
        formData.append('experience',this.user.experience)
        formData.append('about_me',this.user.about_me)
        formData.append('image',this.user.image)
        formData.append('cover_image',this.user.cover_image)

        console.log(adminData)
        // try{
          let data={
            teacherId:adminData.teacherId,
            adminData:formData,
            amount:adminData.amount
          }
        this.$store.dispatch("Teachers/updateTeacher",data)
          .then(res=>{
            this.loading=false
            if(res.status==201){
              // this.$store.state.Teachers.Teachers.Teachers[this.teacherBlock].street=adminData.street
              // this.$store.state.Teachers.Teachers.Teachers[this.teacherBlock].streetNumber=adminData.streetNumber
              // this.$store.state.Teachers.Teachers.Teachers[this.teacherBlock].floor=adminData.floor
              // this.$store.state.Teachers.Teachers.Teachers[this.teacherBlock].door=adminData.door
              // this.$store.state.Teachers.Teachers.Teachers[this.teacherBlock].city=adminData.city
              // this.$store.state.Teachers.Teachers.Teachers[this.teacherBlock].zip=adminData.zip
              this.errorStatus=true
              this.error.code=1
              this.error.message="Successfully updated"
              setTimeout(() => {
                this.$router.push('/teachers')
              }, 500);
            }
          }).catch(error=>{
          this.loading=false
          this.errorStatus=false
          this.error.code=0
          this.error.message="Updating failed"
        })
        // }catch(error){
        //     this.loading=false
        //     this.errorStatus=false
        //     this.error.code=0
        //     this.error.message="Updating failed"
        // }
      },
      onPickImage(image_for) {
        // debugger
        this.image_for=image_for
				this.$refs.imageInput.click();
			},
			OnImagePicked(event) {
        // debugger
        this.temp.temp_preview=[]
				const files = event.target.files;
				let fileName = files[0].name;
				// this.club.club_logo = fileName;
        console.log(files[0])
				if (fileName.lastIndexOf(".") <= 0) {
					// return alert("Please add a valid file! ");
          return
				}else if(files[0].size>1500000){
          return alert("Size")
        }
			  const fileReader = new FileReader();
        let self=this
        fileReader.readAsDataURL(files[0]);
        fileReader.addEventListener("load", () => {
          self.temp.temp_preview.push(fileReader.result)
          // console.log(fileReader.result)
        });
        setTimeout(()=>{
            console.log(this.temp)
            // debugger
            if(this.image_for=='profile'){
              // debugger
              this.user.image=files[0]
              this.user.image_preview=this.temp.temp_preview[0]
            }else if(this.image_for=='cover'){
              this.user.cover_image=files[0]
              this.user.cover_image_preview=this.temp.temp_preview[0]
            }
        },400);

				// this.club.club_logo = files[0];

				// this.club.club_logo_name = files[0].name;

			},
      selectItem(payload, objectName) {
        this.$set(this, objectName, this.translateData(payload));
      },
      addressNullCheck(address){
        if(address==null || address=="null"){
          return ""
        }else{
          return address
        }
      },
      setAddress(Teachers) {
        console.log("Address")
        console.log(Teachers)
        this.user.address.street = Teachers.street;
        this.user.address.streetNumber = Teachers.streetNumber;
        this.user.address.floor = Teachers.floor;
        this.user.address.door = Teachers.door;
        this.user.address.zipCode = Teachers.zipCode;
        this.user.address.city = Teachers.city;
        let oneLineAddress =
          this.addressNullCheck(Teachers.street) +
          " " +
          this.addressNullCheck(Teachers.streetNumber) +
          " " +
          this.addressNullCheck(Teachers.floor) +
          " " +
          this.addressNullCheck(Teachers.door) +
          " " +
          this.addressNullCheck(Teachers.zipCode) +
          " " +
          this.addressNullCheck(Teachers.city);
        this.user.address.oneLineAddress =oneLineAddress.trim()
        this.address=this.user.address

      },
      translateData(address) {
        if (!address || !address.data) {
          return;
        }
        return {
          id: address.data.id,
          street: address.data.vejnavn,
          streetNumber: address.data.husnr,
          floor: address.data.etage,
          door: address.data.dør,
          zipCode: address.data.postnr,
          city: address.data.postnrnavn,
          oneLineAddress: address.tekst

        };
      }
    },
    computed:{
      ...mapState(["Teachers"]),
    },
    components:{
      VueDawa
    },
    mounted() {

      this.TeacherId = this.$route.params.id;
      Store.dispatch("Teachers/getTeacherById", this.TeacherId).then(res => {

      });
      setTimeout(() => {
        this.user.name =this.$store.state.Teachers.Teachers.name;
        this.user.email =this.$store.state.Teachers.Teachers.email;
        this.user.password=this.$store.state.Teachers.Teachers.password;
        this.user.phone =this.$store.state.Teachers.Teachers.phone;
        this.user.dob =this.$store.state.Teachers.Teachers.dob;
        this.user.gender =this.$store.state.Teachers.Teachers.gender;
        this.user.number_plate=this.$store.state.Teachers.number_plate;
        // this.user.schoolName =this.$store.state.Teachers.Teachers.schoolName;
        this.newUseraddress.oneLineAddress =this.$store.state.Teachers.Teachers.city;
        this.newUseraddress.city =this.$store.state.Teachers.Teachers.city;
        this.newUseraddress.state =this.$store.state.Teachers.Teachers.state;
        this.newUseraddress.zipCode =this.$store.state.Teachers.Teachers.zip;
        this.zipCode =this.$store.state.Teachers.Teachers.zip;
        this.role=this.$store.state.Teachers.Teachers.role;
        this.package_id =this.selectedPackage;
        this.teacher_id =this.selectedTeacher;
        this.club_id = Store.state.user.club_id
        this.role="teacher"

      }, 2500);
    },

  };

</script>



// WEBPACK FOOTER //
// src/components/pages/teacher/EditTeacher.vue